export const HOME = { emergentLink: "home-emergent-link" };

export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerRoleFamily: "register-role-family",
  registerRoleSitter: "register-role-sitter",
  registerSubmit: "register-submit-btn",
  logoutBtn: "logout-btn",
};

export const NAV = {
  brand: "nav-brand",
  loginBtn: "nav-login-btn",
  registerBtn: "nav-register-btn",
  dashboard: "nav-dashboard-link",
  search: "nav-search-link",
  bookings: "nav-bookings-link",
  messages: "nav-messages-link",
  profile: "nav-profile-link",
};

export const LANDING = {
  hero: "landing-hero",
  ctaFamily: "landing-cta-family",
  ctaSitter: "landing-cta-sitter",
  ctaFindSitter: "landing-cta-find-sitter",
};

export const FAMILY = {
  dashboard: "family-dashboard",
  editFamily: "family-edit-family-btn",
  addChild: "family-add-child-btn",
  editChild: "family-edit-child-btn",
  familyForm: "family-form",
  familySave: "family-form-save",
  addEmergency: "family-add-emergency-contact",
  addPet: "family-add-pet",
  childForm: "child-form",
  childSave: "child-form-save",
  childDelete: "child-form-delete",
};

export const SITTER = {
  dashboard: "sitter-dashboard",
  editProfile: "sitter-edit-profile-btn",
  profileForm: "sitter-profile-form",
  profileSave: "sitter-profile-save",
  verificationCard: "sitter-verification-card",
  verificationSave: "sitter-verification-save",
};

export const SEARCH = {
  page: "search-page",
  filters: "search-filters",
  submit: "search-submit-btn",
  result: (id) => `search-result-${id}`,
  viewSitter: (id) => `search-view-sitter-${id}`,
};

export const SITTER_DETAIL = {
  page: "sitter-detail-page",
  bookBtn: "sitter-detail-book-btn",
  messageBtn: "sitter-detail-message-btn",
};

export const BOOKING = {
  createForm: "booking-create-form",
  createSubmit: "booking-create-submit",
  list: "bookings-list",
  row: (id) => `booking-row-${id}`,
  accept: (id) => `booking-accept-${id}`,
  decline: (id) => `booking-decline-${id}`,
  pay: (id) => `booking-pay-${id}`,
  complete: (id) => `booking-complete-${id}`,
  review: (id) => `booking-review-${id}`,
};

export const MSG = {
  page: "messages-page",
  threadList: "messages-thread-list",
  thread: (id) => `messages-thread-${id}`,
  composer: "messages-composer-input",
  send: "messages-send-btn",
};
